import { Column, LabelLarge, Row, TitleLarge } from '../../../styles';
import { DashboardSkeletonSVG } from '../../../components/svgs/DashboardSkeletonSVG';
import { IconButton } from '../../../components';
import { Close } from '@mui/icons-material';
import { useToggle } from '../../../hooks';
import { useTranslations } from 'next-intl';
import { getCookieValue, setCookie } from '../../../utils';
import { useEffect } from 'react';
import { IntroductionContainer } from './styles';

export const DashboardScreenIntroduction = () => {
    const t = useTranslations('dashboard');
    const [isVisible, setIsVisible] = useToggle(false);

    useEffect(() => {
        const hasClosedIntroduction = getCookieValue('hide_introduction');
        if (hasClosedIntroduction !== '1') setIsVisible(true);
    });

    const onClick = () => {
        setCookie('hide_introduction', '1', 365);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <IntroductionContainer direction={'row'}>
            <Row width={'100%'} gap={3} pl={2}>
                <Column py={2} gap={2} sx={{ flex: 1 }}>
                    <TitleLarge>{t('onboarding_section_title')}</TitleLarge>
                    <LabelLarge>{t('onboarding_section_text')}</LabelLarge>
                </Column>
                <DashboardSkeletonSVG sx={{ flex: 1 }} />
            </Row>
            <IconButton icon={<Close />} onClick={onClick} />
        </IntroductionContainer>
    );
};
